import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  PageHeader,
  Title,
  SBUIProvider,
  Paragraph,
  Card,
  Select,
  Button,
  Icon,
  PreLoader,
  Table,
  HyperLink,
  Image,
} from '@sydney-broker-ui/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { states } from './constants';
// import { bindActionCreators } from 'redux';
import './ContactUs.css';
import Axios from '../../common/helpers/axiosUtil';
import bpClientLogger from '../../common/helpers/bpClientLogger';
import PAChatbot from '../../components/PAChatbot/PAChatbot';
import withFlags from './../../components/WithFeatureFlags/component';

function ContactUsComponentV2(props) {
  const [pageLoad, setPageLoad] = useState(true);
  const [showStateContact, setShowStateInfo] = useState(false);
  const [contactLists, setContactLists] = useState({ status: 'LOADING', data: [] });
  const [stateID, setStateID] = useState(null);
  const [stateName, setStateName] = useState(null);
  const [showLoginButton, setShowLoginButton] = useState(true);
  const [disableChat, setDisableChat] = useState(false);

  const statesList = props.flags?.contactUsStates || states;

  const updateStateID = e => {
    setStateID(e?.target?.value);
    setShowStateInfo(true);
  };

  useEffect(() => {
    const queryParams = props?.location?.query;
    if (props?.route?.isPrivate) {
      if (props.bpUserInfo) {
        setShowLoginButton(false);
        setPageLoad(false);
        if (queryParams.op === 'chat') {
          const delayTimeout = props?.paChatbot?.acaOpenDelayTimeout || 3000;
          setTimeout(() => {
            openACAUI();
          }, delayTimeout);
        }
      }
    } else {
      setPageLoad(false);
    }
  }, []);

  useEffect(() => {
    setContactLists({ status: 'LOADING', data: [] });
    const URL = `/apps/ptb/public/api/contactus/${stateID}`;
    const name = statesList.filter(state => state.value === stateID);
    setStateName(name[0]?.label);

    if (stateID) {
      Axios.get(URL)
        .then(data => {
          if (data?.pageSlotList?.length > 0) {
            const pageSlotList = data?.pageSlotList[0];
            const wraSlotList = pageSlotList?.wraSlotList;
            if (wraSlotList.length > 0) {
              const contactList = wraSlotList[0].rawJSON?.categories;
              setContactLists({ status: 'SUCCESS', data: contactList });
            }
          }
        })
        .catch(err => {
          setStateName(null);
          // props.messagingActions.showError(errorMessagesInfo?.serviceDown, 5000);
          setContactLists({ status: 'ERROR', data: [] });
          bpClientLogger.error(`Failed Fetching info for state:  ${err}`);
        });
    }
  }, [stateID]);

  const showContacts = channels => {
    let i = 0;
    return channels.map(element => {
      for (var key in element) {
        return (
          <tr key={`${key.replaceAll(' ', '')}${i++}`}>
            <td width="25%" className="listText">
              {key}:
            </td>{' '}
            <td width="75%">
              {element[key]?.toString().includes('@') ? (
                <HyperLink
                  href={`mailto:${element[key] || ''}`}
                  linkType="icon"
                  data-analytics="br.contactusstateemail"
                >
                  {' '}
                  {element[key]}{' '}
                </HyperLink>
              ) : (
                element[key]
              )}
            </td>
          </tr>
        );
      }
    });
  };

  const openACAUI = () => {
    window.gAcaProps.application = 'contactus-PTB';
    window.postMessage('open_aca_chat', window.location.origin);
  };

  const closeACAUI = () => {
    window.postMessage('close_aca_chat', window.location.origin);
  };

  const redirectLogin = () => {
    const contactUrl = '/apps/ptb/contactus?op=chat';
    window.location.assign(`${window.location.origin}${contactUrl}`);
  };

  return (
    <SBUIProvider>
      {!pageLoad ? (
        <>
          <PageHeader className="greetings-container">
            <div className="sbui-container greetings-section">
              <div className="center">
                <Title type="white" className={`capitalize-first-letter greetings-text`}>
                  {'Contact Us'}
                </Title>
              </div>
            </div>
          </PageHeader>
          {!showStateContact ? (
            <>
              <Row>
                <Col>
                  <div className="contact-title-section">
                    <Title className={`capitalize-first-letter greetings-text`}>{'We’re Here To Help'}</Title>
                    <Paragraph>
                      We want to make sure you get the answers you need. <b>Save time by chatting</b> with our Producer
                      Assistant who can connect you to a live agent.
                      <br />
                      You can also always email or call us &#8212; just select a state below.
                    </Paragraph>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="contact-footer-section">
                    <Icon name="info" className="la-3x infoIcon" />
                    <Paragraph>
                      <span>
                        Live Chat is available during business hours that vary by state, but you can chat with our
                        Producer Assistant 24/7.
                      </span>
                    </Paragraph>
                  </div>
                </Col>
              </Row>
              <Row className={'contact-box'}>
                <Col className={'contact-box-layout'}>
                  <Card>
                    <div className="contact-icon-box">
                      <div className="contact-icon-box-inner">
                        <Icon name="chat" className="la-3x" style={{ padding: '10px' }} />
                      </div>
                    </div>
                    <div className="contact-chat-box">
                      <Title level="2">{'Chat With Us'}</Title>
                      <Paragraph>
                        Use the chat for answers to questions on client status, enrollment, billing, and more.
                      </Paragraph>
                      {showLoginButton ? (
                        <Button onClick={redirectLogin} data-analytics="br.logintochat">
                          Log In To Chat
                        </Button>
                      ) : (
                        <Button disabled={disableChat} onClick={openACAUI} data-analytics="br.logintochat">
                          Start Chat
                        </Button>
                      )}
                    </div>
                  </Card>
                </Col>
                <Col className={'contact-box-layout'}>
                  <Card>
                    <div className="contact-icon-box">
                      <div className="contact-icon-box-inner">
                        <Icon name="phone" className="la-3x" style={{ padding: '10px' }} />
                      </div>
                    </div>
                    <div className="contact-email-box">
                      <Title level="2">{'Email/Call Us'}</Title>
                      <Paragraph>
                        Start by selecting your state to get the most up to date contact information.
                      </Paragraph>
                      <Select onChange={val => updateStateID(val)} options={statesList} />
                    </div>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col className={'contact-box-contact'}>
                  <Card flat>
                    <Row wrap>
                      <Col lg="9" md="9" sm="12">
                        <Title level="2" className={`capitalize-first-letter greetings-text`}>
                          {'Chat With Us Now'}
                        </Title>
                        <Paragraph>
                          Chat with our Producer Assistant or a live agent to get the answers you need.
                        </Paragraph>
                      </Col>
                      <Col lg="3" md="3" sm="12" className={'contact-list-button-box'}>
                        {showLoginButton ? (
                          <Button onClick={redirectLogin} data-analytics="br.logintochat">
                            Log In To Chat
                          </Button>
                        ) : (
                          <Button disabled={disableChat} onClick={openACAUI} data-analytics="br.logintochat">
                            Start Chat
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col className={'contact-box-email-contact'}>
                  <Card flat>
                    <Row wrap>
                      <Col>
                        <Title level="2" className={`capitalize-first-letter greetings-text`}>
                          {stateName}
                        </Title>
                        <Paragraph className={'contact-list-paragraph'}>
                          {`Different states have different contact information. If you're not looking for information for ${stateName}, change your state below..`}
                        </Paragraph>
                      </Col>
                      <Col lg="3" md="6" sm="12" className={'contact-list-select'}>
                        <Select onChange={val => updateStateID(val)} options={statesList} value={stateID} />
                      </Col>
                    </Row>
                    <Row wrap>
                      {contactLists.status === 'LOADING' && (
                        <div className="contact-loading-block ">
                          <PreLoader message="Data is loading, please wait ..." />
                        </div>
                      )}
                      {contactLists.status === 'SUCCESS' &&
                        contactLists?.data.map((list, key) => {
                          return (
                            <Col
                              lg="6"
                              md="6"
                              sm="12"
                              className={'contact-list-box'}
                              key={`${list?.name.replaceAll(' ', '')}${key}`}
                            >
                              <Title level="3" className={`capitalize-first-letter greetings-text`}>
                                {list?.name}
                              </Title>
                              {list?.topics?.map((topic, i) => {
                                return (
                                  <div key={`${list?.name.replaceAll(' ', '')}${i}`}>
                                    {topic?.type !== '' && (
                                      <Paragraph>
                                        <b>{topic?.type}</b>
                                      </Paragraph>
                                    )}
                                    <Table noBorders={false} className={'contact-table'} key={`${i}`}>
                                      <tbody>{showContacts(topic?.channels)}</tbody>
                                    </Table>
                                  </div>
                                );
                              })}
                            </Col>
                          );
                        })}
                      {contactLists.status === 'ERROR' && (
                        <div className="contact-error-block ">
                          <div className="error-parent">
                            <div className="error-item">
                              <Image
                                alt="Error PCP"
                                height={'62px'}
                                width={'96px'}
                                src={'/apps/ptb/public/images/Illustration.png'}
                              />
                            </div>
                          </div>
                          <div className="contact-error">
                            <Paragraph>
                              <strong>We ran into a problem loading this information.</strong>
                            </Paragraph>
                            <Paragraph>
                              Please try again later or contact User Software Support (USS) at 888-268-4361.
                            </Paragraph>
                          </div>
                        </div>
                      )}
                    </Row>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </>
      ) : (
        <Row></Row>
      )}

      {props?.route?.isPrivate && window?.location?.pathname?.split?.('/apps/ptb/').pop() !== 'admin' && (
        <div>
          <PAChatbot flags={props?.flags} />
        </div>
      )}
    </SBUIProvider>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    bpUserInfo: state?.homeReducers?.bpUserInfo,
    bpUserAceProfile: state?.homeReducers?.bpUserAceProfile,
    config: get(state?.homeReducers, 'config.data'),
    paChatbot: state?.homeReducers?.config?.data?.features?.paChatbot || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // messagingActions: bindActionCreators(messagingActions, dispatch),
  };
}

ContactUsComponentV2.propTypes = {
  bpUserInfo: PropTypes.object,
  messagingActions: PropTypes.object,
  flags: PropTypes.object,
  bpUserAceProfile: PropTypes.object,
  config: PropTypes.object,
  showSidebar: PropTypes.bool,
  location: PropTypes.object,
  isPrivate: PropTypes.bool,
  route: PropTypes.object,
  paChatbot: PropTypes.object,
};

export default withFlags(connect(mapStateToProps, mapDispatchToProps)(ContactUsComponentV2));
